import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { FormGroup, Label } from 'reactstrap';
import map from 'lodash/map';
import styles from './RadioField.scss';

class RadioField extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    inputProps: PropTypes.object,
    meta: PropTypes.object,
    error: PropTypes.string,
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })).isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func,
  }

  onBlur = (e) => {
    // BUGFIX for IE - stack issues when running onBlur
    const ua = window.navigator.userAgent;
    const old_ie = ua.indexOf('MSIE ');
    const new_ie = ua.indexOf('Trident/');

    if ((old_ie == -1) && (new_ie == -1)) {
      this.props.onBlur(e);
    }
  }

  renderOption(option) {
    return (
      <FormGroup check key={option.value} className={styles.field}>
        <Label check>
          <Field
            name={this.props.input.name}
            onBlur={this.onBlur}
            value={option.value}
            component="input"
            type="radio"
            disabled={option.disabled}
            onChange={this.props.onChange}
          />
          {option.text}
        </Label>
      </FormGroup>
    );
  }

  render() {
    const errorClass = (this.props.className &&
      this.props.className.includes('is-invalid')) ? 'is-invalid' : null;

    return (
      <FormGroup row className={errorClass}>
        <div className="col-12">
          {map(this.props.data, (option) => this.renderOption(option))}
        </div>
      </FormGroup>
    );
  }
}

const wrapper = (props, error, componentProps) => (
  <RadioField {...props} {...componentProps} className={componentProps.className} />
);

export default wrapper;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/RadioField.jsx